export default __webpack_public_path__ + "static/3-2dfc021d6611e37f9a1154eb88e018b8.png";